import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Button } from '@mentimeter/ragnar-ui/button';
import {
  ModalBody,
  ModalContainer,
  ModalDismiss,
  ModalFooter,
  ModalHeader,
  ModalRoot,
} from '@mentimeter/ragnar-ui/modal';
import { LearningIllustration } from '@mentimeter/ragnar-visuals/spotlight';
import { gray1300 } from '@mentimeter/ragnar-colors';
import React from 'react';

export const WelcomeModal = ({
  open,
  handleClick,
}: {
  open: boolean;
  handleClick: () => void;
}) => {
  const bodyMessage = `Let's get you started setting up slides, learn how participants join, and nailing your presentation.`;
  const buttonText = 'Get started';

  return (
    <ModalRoot open={open}>
      <ModalContainer
        maxWidth="420px"
        pt="space12"
        pb="space4"
        px="space2"
        dismissable={false}
      >
        <Box mx="space6" width="131px" height="131px">
          <LearningIllustration userColor={gray1300} />
        </Box>
        <ModalHeader dismissable={false}>
          <Text variant="contentHero4" fontSize="400">
            <span style={{ color: 'var(--color-brand)' }}>HI</span>{' '}
            <span style={{ color: 'var(--color-text)' }}>THERE!</span>
          </Text>
        </ModalHeader>
        <ModalBody>
          <Text variant="dashboardBodyMd">{bodyMessage}</Text>
        </ModalBody>
        <ModalFooter justifyContent="flex-start">
          <ModalDismiss>
            <Button variant="primary" onClick={handleClick}>
              {buttonText}
            </Button>
          </ModalDismiss>
        </ModalFooter>
      </ModalContainer>
    </ModalRoot>
  );
};
